import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { getSubtitleTracks } from './api';

export const useQuerySubtitleTracks = (mediaId: string, enabled = true) => useQuery({
  queryKey: [...QUERY_KEYS.media(mediaId), 'subtitles'],
  queryFn: () => getSubtitleTracks(mediaId),
  enabled: enabled && Boolean(mediaId),
});
